import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import Login from '../pages/Auth/Login'
import { AuthLayout } from '../components/layouts'
import ForgotPassword from '../pages/Auth/ForgotPassword'
import ResetPassword from '../pages/Auth/ResetPassword'
import Register from '../pages/Auth/Register'
import { useSelector } from 'react-redux'

const AuthRouter = () => {
  const user = useSelector((state) => state.userAuth.user)

  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route
          path={'se-connecter'}
          element={user ? <Navigate to="/user" /> : <Login />}
        />
        <Route
          path={'mot-de-passe-oublie'}
          element={user ? <Navigate to="/user" /> : <ForgotPassword />}
        />
        <Route
          path={'reinitialisation-mot-de-passe/:token'}
          element={user ? <Navigate to="/user" /> : <ResetPassword />}
        />
        <Route
          path={'inscription'}
          element={user ? <Navigate to="/user" /> : <Register />}
        />
        <Route
          path={'inscription/entreprise'}
          element={
            user ? (
              <Navigate to="/user" />
            ) : (
              <Register typeRegister={'entreprise'} />
            )
          }
        />
        <Route
          path={'inscription/candidat'}
          element={
            user ? (
              <Navigate to="/user" />
            ) : (
              <Register typeRegister={'candidat'} />
            )
          }
        />
      </Route>
    </Routes>
  )
}

export default AuthRouter
